import {Theme} from '../classes/theme';

export const base = Theme.create('base')
  // Colors
  .property('primary.color', '#86b302')
  .property('primary.contrastColor', '#fff')
  .property('primary.font', 'Lato')

  // Logo
  .property('logo.text.color', '#2D2A26')

  // border radius
  .property('border.radius', '4px')

  // Page
  .property('page.background.color', '#fff')
  .property('page.product.taglets.visible', '0')

  // Headings
  .property('heading1.font', Theme.ref('primary.font'))
  .property('heading1.transform', 'none')
  .property('heading2.font', Theme.ref('primary.font'))
  .property('heading2.transform', 'none')
  .property('heading3.font', Theme.ref('primary.font'))
  .property('heading3.transform', 'none')

  // Text
  .property('text.font', 'Lato')
  .property('text.color', '#222')
  .property('text.shadow', 'none')
  .property('text.border.radius', Theme.ref('border.radius'))
  .property('text.background.color', '#0000')
  .property('text.fullBackground.color', '#0000')

  // Menu
  .property('menu.background.color', '#fff')
  .property('menu.text.font', 'Lato')
  .property('menu.text.color', '#222')
  .property('menu.text.transform', 'uppercase')

  // Image
  .property('image.border.radius', Theme.ref('border.radius'))
  .property(
    'image.default',
    'https://images.teemill.com/wn8sribf9hc5ffoer60koletlsowcraemgbludl90lgrn7gc.png.jpg'
  )

  // Image
  .property('video.default', 'R51EkLZ3qYE')

  // Banners
  .property('banner.text.shadow', 'none')
  .property('banner.title.color', '#fff')
  .property('banner.title.background.color', '#0000')
  .property('banner.copy.color', '#fff')
  .property('banner.copy.background.color', '#0000')
  .property('banner.fullBackground.color', '#0000')

  // Buttons
  .property('button.primary.color', Theme.ref('primary.color'))
  .property('button.secondary.color', Theme.ref('text.color'))
  .property('button.border.radius', Theme.ref('border.radius'))
  .property('button.fullBackground.color', '#0000')

  // Features
  .property('feature.icon.color', '#fff') // !deprecated
  .property('feature.border.radius', Theme.ref('border.radius'))
  .property('feature.background.color', '#0000')
  .property('feature.text.color', Theme.ref('text.color'))
  .property('feature.text.background.color', '#0000') // !deprecated
  .property('feature.fullBackground.color', '#0000')

  // Quote
  .property('quote.text.font', Theme.ref('heading2.font'))
  .property('quote.text.color', Theme.ref('text.color'))
  .property('quote.text.shadow', Theme.ref('text.shadow'))
  .property('quote.border.radius', Theme.ref('border.radius'))
  .property('quote.background.color', '#0000')
  .property('quote.fullBackground.color', '#0000')

  // !deprecated
  // Announcement
  .property('announcement.text.font', Theme.ref('heading2.font'))
  .property('announcement.text.color', '#fff')
  .property('announcement.text.shadow', Theme.ref('text.shadow'))
  .property('announcement.border.radius', Theme.ref('border.radius'))
  .property('announcement.fullBackground.color', '#0000')

  // AnnouncementV2
  .property('announcement.v2.text.color', Theme.ref('text.color'))
  .property('announcement.v2.text.shadow', 'none')
  .property('announcement.v2.border.radius', Theme.ref('border.radius'))
  .property('announcement.v2.background.color', '#0000')
  .property('announcement.v2.fullBackground.color', '#0000')

  // !deprecated
  // Card
  .property('card.text.font', Theme.ref('heading3.font'))
  .property('card.text.color', '#fff')
  .property('card.text.shadow', Theme.ref('text.shadow'))
  .property('card.border.radius', Theme.ref('border.radius'))
  .property('card.fullBackground.color', '#0000')

  // Newsletter
  .property('newsletter.text.color', Theme.ref('text.color'))
  .property('newsletter.title.font', Theme.ref('heading2.font'))
  .property('newsletter.border.radius', Theme.ref('border.radius'))
  .property('newsletter.background.color', '#0000')
  .property('newsletter.fullBackground.color', '#0000')

  // Gate
  .property('gate.text.color', '#fff')
  .property('gate.text.shadow', Theme.ref('text.shadow'))
  .property('gate.border.radius', Theme.ref('border.radius'))
  .property('gate.fullBackground.color', '#0000')

  // Footer
  .property('footer.visible', '1')
  .property('footer.text.color', '#222')
  .property('footer.background.color', '#fff')

  // Forms
  .property('form.background.primary.color', Theme.ref('page.background.color'))
  .property('form.background.secondary.color', '#eee')
  .property('form.border.color', '#dfdfdf')
  .property('form.border.radius', Theme.ref('border.radius'))
  .property('form.border.focused.color', Theme.ref('form.border.color'))
  .property('form.border.error.color', Theme.ref('error.color'))
  .property('form.text.primary.color', Theme.ref('text.color'))
  .property('form.text.secondary.color', '#767676')
  .property('form.text.error.color', Theme.ref('error.color'))

  // Tag
  .property('tag.background.color', Theme.ref('box.background.color'))
  .property('tag.border.color', Theme.ref('box.background.color'))
  .property('tag.text.color', Theme.ref('text.color'))

  // Misc
  .property('box.background.color', '#f3f3f3')
  .property('border.color', '#dfdfdf')

  // Indicators
  .property('error.color', '#dd176d')
  .property('error.color.dark', '#6a0b34')
  .property('warning.color', '#f89815')
  .property('warning.color.dark', '#714203')
  .property('success.color', '#86b302')
  .property('success.color.dark', '#3a4e01')

  // Product page
  .property('productPage.ugc.title.text', 'From the community')
  .property('productPage.ugc.subtitle.text', '')
  .property('productPage.quantitySelector.visible', '0')
  .property('productPage.description.word.limited', '0')
  .property('productPage.description.placement', 'aboveSelectors')
  .property('productPage.color.selector.border.radius', '2px')
  .property('productPage.size.selector.border.radius', '2px')
  .property('productPage.imageCarousel.update.form', '0')
  .property('productPage.thumbnails.layout', 'grid')
  .property('productPage.convertedPrice.roundTo', '1')
  .property('productPage.imageCarousel.loop', '1')
  .property('productPage.recommendations.scope', 'division') // 'division' | 'collection' - include any products from the same division or just the active product's collection

  // Checkout
  .property('checkout.address.showBusinessFields', '0')
  .property('checkout.address.splitStreetAddress', '0')

  // Receipt
  .property('receipt.shipping.showEstimates', '1');
